import { render } from "./ApplicationDetail.vue?vue&type=template&id=2d6eb2c5&scoped=true"
import script from "./ApplicationDetail.vue?vue&type=script&lang=js"
export * from "./ApplicationDetail.vue?vue&type=script&lang=js"

import "./ApplicationDetail.vue?vue&type=style&index=0&id=2d6eb2c5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d6eb2c5"]])

export default __exports__